import React from 'react';
import ButtonRow from '../../components/ButtonRow';

const FormActionsRow = ({ onSend, onAbort, additionalProps = {} }) => (
  <ButtonRow
    withBottomSpace={'true'}
    secondaryBtn={
      onAbort
        ? {
            label: 'Abbruch',
            onClick: onAbort,
            additionalProps: additionalProps.onAbort,
          }
        : null
    }
    primaryBtn={{
      label: 'Abschicken',
      onClick: onSend,
      additionalProps: additionalProps.onSend,
    }}
  />
);

export default FormActionsRow;
